import { gql } from "@apollo/client";
export const typeDef = gql`
  type Result {
    url: String
  }
  type Query {
    advertising(id: Int): Result
  }
`;
export const resolvers = {
  Query: {
    advertising: async (_parent, _ref, _ref2) => {
      var _result$creatives;
      let {
        id
      } = _ref;
      let {
        dataSources
      } = _ref2;
      const result = await dataSources.advertising.getAdvertising(id);
      const url = result === null || result === void 0 || (_result$creatives = result.creatives) === null || _result$creatives === void 0 || (_result$creatives = _result$creatives[0]) === null || _result$creatives === void 0 ? void 0 : _result$creatives.url;
      return {
        url
      };
    }
  }
};